var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-tabs"},[_c('b-nav',{attrs:{"tabs":""}},[_c('b-nav-item',{attrs:{"disabled":""}},[_c('b',[_vm._v("Quiz App")])]),_c('b-nav-item',{attrs:{"disabled":""}},[_c('b',[_vm._v("Counter [ correct / total ] : "+_vm._s(_vm.numCorrect)+" / "+_vm._s(_vm.numTotal)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }